export function formatDateYYYYMMDD(ms) {
  const date = new Date(ms); // 创建一个日期对象
  const year = date.getFullYear(); // 获取年份
  let month = date.getMonth() + 1; // 获取月份，从0开始，所以要加1
  let day = date.getDate(); // 获取日期
  // 如果月份或日期小于10，要在前面加0
  if (month < 10) {
    month = '0' + month;
  }
  if (day < 10) {
    day = '0' + day;
  }
  // 拼接成 yyyy-mm-dd 格式
  return year + '-' + month + '-' + day;
}
